import React from 'react'
import Header from '../components/Header'
import { Likes } from '../components/Likes'
import { Watchlater } from '../components/Watchlater'

export default function Likespage() {
  return (
    <>
    <Header/>
    <Likes/>
    </>
  )
}
